export default __webpack_public_path__ + "6ecc2ca406ea31348ee5e63059fe868f.png";